/* istanbul ignore file */
import gql from 'graphql-tag';

export default gql`
  mutation addCustomerBoardVendorVariant(
    $customerBoardId: ID!,
    $sourceBoardId: ID,
    $vendorVariantId: ID!
  ) {
    addCustomerBoardVendorVariant(
      customerBoardId: $customerBoardId,
      sourceBoardId: $sourceBoardId,
      vendorVariantId: $vendorVariantId
    ) {
      customerPrimaryImage
      exploreBoardItems(limit: 9) {
        imageUrl
      }
      id
    }
}
`;
